import { render, staticRenderFns } from "./envelopeChats.vue?vue&type=template&id=a3c61550&scoped=true"
import script from "./envelopeChats.vue?vue&type=script&lang=js"
export * from "./envelopeChats.vue?vue&type=script&lang=js"
import style0 from "./envelopeChats.vue?vue&type=style&index=0&id=a3c61550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c61550",
  null
  
)

export default component.exports